import PropTypes from 'prop-types'
import { useResponsive } from 'src/hooks/use-responsive'

// @mui
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import { Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'
import LinearProgress from '@mui/material/LinearProgress'

// components
import Iconify from 'src/components/iconify'
import NotificationReport from './notification-type-report'

export default function NotificationModal({
  currentModalAction,
  openModal,
  setOpenModal,
  setSelected,
  setOpenDrawer,
  section,
}) {
  const components = NotificationReport

  const mdDown = useResponsive('down', 'md')

  const Component = components

  const close = () => {
    setOpenModal(false)
    setSelected(null)
  }

  return (
    currentModalAction && (
      <Dialog
        fullWidth
        open={openModal}
        maxWidth='sm'
        onClose={() => close()}
        hideBackdrop
        sx={{
          position: 'fixed',
          zIndex: 1300,
          right: 0,
          bottom: 0,
          top: 0,
          left: 0,
          width: mdDown ? '60%' : 'calc(50% - 64px)',
          marginRight: '26%',
          marginLeft: mdDown ? 0 : '26%',
        }}
      >
        <DialogTitle>
          <Box display='flex' alignItems='center'>
            <Box flexGrow={1}>
              <Typography variant='h4'>{currentModalAction.title}</Typography>
            </Box>
            <Box>
              <IconButton onClick={() => close()}>
                <Iconify icon='mdi:close' />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ overflow: 'hidden', py: 2 }}>
          <Stack sx={{ mb: 3, backgroundColor: 'action.hover', borderRadius: 1, px: 2, py: 1 }}>
            {currentModalAction.type && (
              <Typography variant='body1' sx={{ mb: 1 }}>
                Tipologia: {currentModalAction.type}
              </Typography>
            )}
            {currentModalAction.data && (
              <Typography variant='body1' sx={{ mb: 1 }}>
                Data: {currentModalAction.date}
              </Typography>
            )}
            {currentModalAction.resource && (
              <Typography variant='body1'>Risorsa: {currentModalAction.resource}</Typography>
            )}
          </Stack>

          <Typography variant='h6' sx={{ mb: 2 }}>
            {section === 'notification' ? "Esito dell'operazione" : 'Stato di completamento'}
          </Typography>
          <Stack flexDirection='row' spacing={1} alignItems='center'>
            {section === 'notification' && (
              <Iconify
                icon={
                  currentModalAction.errors && currentModalAction.errors.length !== 0
                    ? 'solar:close-circle-bold'
                    : 'solar:check-circle-bold'
                }
                width={24}
                sx={{
                  color:
                    currentModalAction.errors && currentModalAction.errors.length !== 0
                      ? '#e03636'
                      : '#358d4c',
                }}
              />
            )}
            <Typography variant='body1' flexGrow={1}>
              {currentModalAction.text}
            </Typography>

          </Stack>



          {Component && currentModalAction.errors && currentModalAction.errors.length !== 0 && (
            <Component
              values={currentModalAction.errors}
              setOpenModal={setOpenModal}
              setOpenDrawer={setOpenDrawer}
            />
          )}
        </DialogContent>
      </Dialog>
    )
  )
}

NotificationModal.propTypes = {
  currentModalAction: PropTypes.object,
  openModal: PropTypes.bool,
  setOpenModal: PropTypes.func,
  setSelected: PropTypes.func,
  setOpenDrawer: PropTypes.func,
  section: PropTypes.string,
}
